import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[sdNamedTemplate]',
  standalone: true,
})
export class NamedTemplateDirective<TName extends string, TData = undefined> {
  @Input({ required: true }) sdNamedTemplate: TName;
  // any data what you want to pass to the template
  @Input() data?: TData;

  get name(): TName {
    return this.sdNamedTemplate;
  }

  constructor(public readonly template: TemplateRef<unknown>) {}
}
